

/**
 * @name ImageCropModalController
 * @description Function to handle the image crop modal
 * @param {file} resolve The image to crop and save
 */
function ImageCropModalController() {
  let vm = this;

  vm.$onInit = function() {
    vm.cropper = {
      croppedImage: null,
      sourceImage: vm.resolve.image
    };
    vm.rotate = rotate;
    vm.saveCroppedPhoto = saveCroppedPhoto;
  };

  /**
   * @name saveCroppedPhoto
   * @description Function to save the cropped image
   * @param {string} image The base64 image string
   */
  function saveCroppedPhoto(image) {
    vm.close({$value: image});
  }

  /**
   * @name rotate
   * @description Function to rotate images in the crop modal
   */
  function rotate() {
    // rotateBase64Image(inputImage);
    vm.cropper.sourceImage.rotation += 90; // 90 deg rotation
  }

  vm.cancel = function() {
    vm.dismiss({$value: 'cancel'});
  };
}

angular
.module('inkfinder')
.controller('ImageCropModalController', ImageCropModalController);



// WEBPACK FOOTER //
// ./components/image/crop-modal/image-crop-modal.controller.js